/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nhs/clock': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 6v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" _stroke="#1B365D" stroke-width="2" stroke-linecap="round" fill="none" stroke-linejoin="round"/>'
  }
})
